var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptysStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 26.6666H63.3333M16.6667 26.6666C14.8986 26.6666 13.2029 25.9642 11.9526 24.714C10.7024 23.4637 10 21.768 10 19.9999C10 18.2318 10.7024 16.5361 11.9526 15.2859C13.2029 14.0356 14.8986 13.3333 16.6667 13.3333H63.3333C65.1014 13.3333 66.7971 14.0356 68.0474 15.2859C69.2976 16.5361 70 18.2318 70 19.9999C70 21.768 69.2976 23.4637 68.0474 24.714C66.7971 25.9642 65.1014 26.6666 63.3333 26.6666M16.6667 26.6666V59.9999C16.6667 61.768 17.369 63.4637 18.6193 64.714C19.8695 65.9642 21.5652 66.6666 23.3333 66.6666H56.6667C58.4348 66.6666 60.1305 65.9642 61.3807 64.714C62.631 63.4637 63.3333 61.768 63.3333 59.9999V26.6666M33.3333 39.9999H46.6667",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptysStock);
export default __webpack_public_path__ + "static/media/Emptys_Stock.6a07f3e326f170e60e725e8dcb007dcb.svg";
export { ForwardRef as ReactComponent };